import React from 'react';
import MDatePicker from 'assets/js/datepicker';
import { Route, withRouter } from 'react-router-dom';
import { Transition, TransitionGroup } from 'react-transition-group';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { dateFormat } from 'config/settings';
import { modalPathFor } from 'config/paths';

const defaultOptions = (t) => ({
    autoClose: true,
    defaultDate: moment().toDate(),
    setDefaultDate: true,
    i18n: {
        cancel: t('Cancel'),
        clear: t('datepicker_clear'),
        done: t('Ok'),
        previousMonth: '‹',
        nextMonth: '›',
        months: [
            t('month_january'),
            t('month_february'),
            t('month_march'),
            t('month_april'),
            t('month_may'),
            t('month_june'),
            t('month_july'),
            t('month_august'),
            t('month_september'),
            t('month_october'),
            t('month_november'),
            t('month_december')
        ],
        monthsShort: [
            t('month_jan'),
            t('month_feb'),
            t('month_mar'),
            t('month_apr'),
            t('month_may_short'),
            t('month_jun'),
            t('month_jul'),
            t('month_aug'),
            t('month_sep'),
            t('month_oct'),
            t('month_nov'),
            t('month_dec')
        ],
        weekdays: [
            t('weekday_sunday'),
            t('weekday_monday'),
            t('weekday_tuesday'),
            t('weekday_wednesday'),
            t('weekday_thursday'),
            t('weekday_friday'),
            t('weekday_saturday')
        ],
        weekdaysShort: [
            t('weekday_sun'),
            t('weekday_mon'),
            t('weekday_tue'),
            t('weekday_wed'),
            t('weekday_thu'),
            t('weekday_fri'),
            t('weekday_sat')
        ],
        weekdaysAbbrev: [
            t('weekday_s'),
            t('weekday_m'),
            t('weekday_t'),
            t('weekday_w'),
            t('weekday_th'),
            t('weekday_f'),
            t('weekday_sa')
        ]
    }
})

class RouteDatePicker extends React.Component {

    constructor(props) {
        super(props);
        this.pickerRef = React.createRef();
        this.handleManualClose = this.handleManualClose.bind(this);
        this.close = this.close.bind(this);
        this.popped = false;
    }

    render() {

        return (
            <input type="text" className="datepicker hidden" ref={this.pickerRef} />
        )
    }

    componentDidMount() {
        const { t } = this.props;
        this.picker = MDatePicker.init(this.pickerRef.current, { ...defaultOptions(t), ...this.props.options, onClose: this.handleManualClose, onSetInput: this.onSetInput });
        this.picker.open();
    }

    componentDidUpdate() {
        if (!this.popped && this.props.status === 'exiting') {
            this.popped = true;
            this.picker.close();
        }
    }

    componentWillUnmount() {
        if(this.picker) {
            this.picker.close();
            this.picker.destroy();
        }
    }

    handleManualClose() {
        if(!this.popped) {
            this.popped = true;
            this.props.history.goBack();
        }
    }

    onSetInput = (date) => {
        const { name, setFieldValue } = this.props;

        setFieldValue(name,moment(date).format(dateFormat));
    }

    close() {
        this.picker.close();
    }
}

let DatePicker = ({ triggerRender, suffix, t, ...props }) => {

    const { location, location: { pathname }, match, history, ...otherProps } = props;
    const { options: { inDuration } = {} } = props;
    const path = modalPathFor(suffix,pathname);

    return (
        <React.Fragment>
            {triggerRender && triggerRender({ onClick: () => history.push(path)})}
            <TransitionGroup>
                <Transition key={pathname} timeout={inDuration || 300}>
                    { state => (
                        <Route location={location} path={path} exact render={(routeProps) => {
                            return(
                                <RouteDatePicker {...routeProps} {...otherProps} t={t} status={state} />
                            )
                        }} />
                    )}
                </Transition>
            </TransitionGroup>
        </React.Fragment>
    )

}

DatePicker = withTranslation()(withRouter(DatePicker));

export default DatePicker;
